/*
  get Config item flow
  There's a lot of logic in relationships so we've broken them out into different flows so relationships-modal doesn't get too crowded
*/
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  RT_CONFIGURATION_ITEM,
  configItemWithUAYes,
  MOBILE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { RT_CI_UNAVAILABILITY } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import {
  getFormDataFieldValue,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import moment from 'moment';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import { START_AND_END_DATE } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/section-three';
import { scheduledStartDate } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/scheduled-start-date';
import { scheduledEndDate } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/scheduled-end-date';
import { configurationItem } from './configuration-item';
import { configurationItemWithUnavailability } from './configuration-item-with-unavailability';
import { configItemUaType } from './configuration-item-ua-type';
import { uaScheduledStartDate } from './ua-scheduled-start-date';
import { uaScheduledEndDate } from './ua-scheduled-end-date';
import { sstUaScheduledStartDate } from './sst-ua-scheduled-start-date';
import { sstUaScheduledEndDate } from './sst-ua-scheduled-end-date';

// get the min / max dates for scheduled start and end date.
const getDateConstraints = (formData) => {
  const crqStartDate = getFormDataFieldValue({
    formData,
    sectionId: START_AND_END_DATE,
    fieldId: scheduledStartDate.id,
  });
  const crqStartMoment = crqStartDate ? moment.tz(crqStartDate, DEFAULT_TIMEZONE) : null;
  const crqEndDate = getFormDataFieldValue({
    formData,
    sectionId: START_AND_END_DATE,
    fieldId: scheduledEndDate.id,
  });
  const crqEndMoment = crqEndDate ? moment.tz(crqEndDate, DEFAULT_TIMEZONE) : null;
  return ({
    initialStartDate: crqStartDate,
    initialEndDate: crqEndDate,
    minDate: crqStartMoment,
    maxDate: crqEndMoment,
  });
};

const getConfigItemFlow = (params = {}) => {
  const {
    relationshipTypeValue,
    values,
    // touched,
    // userRoles,
    // sectionId,
    // // the form that exists outside of the modal form
    outerFormData,
  } = params;


  const shouldRender = relationshipTypeValue === RT_CONFIGURATION_ITEM;
  const isCiUnavalability = relationshipTypeValue === RT_CI_UNAVAILABILITY;


  const currentFields = [];

  currentFields.push({
    ...defaultFieldLogic,
    componentData: configurationItem,


    shouldRender,
    shouldValidate: shouldRender,
    overwriteSubmit: {
      overwrite: !shouldRender && !isCiUnavalability,
      overwriteValue: null,
    },
  });

  // show the UA question if we have selected a config item
  const configItemSelected = values && values[configurationItem.id];
  const shouldRenderWithUa = shouldRender && configItemSelected;

  currentFields.push({
    ...defaultFieldLogic,
    componentData: configurationItemWithUnavailability,


    shouldRender: shouldRenderWithUa,
    shouldValidate: shouldRenderWithUa,
    overwriteSubmit: {
      overwrite: !shouldRenderWithUa,
      overwriteValue: null,
    },
  });

  // show the UA form if we have said 'Yes' to 'with unavailability'
  // or this is a CIUnavailability
  const configItemWithUAValue = values && values[configurationItemWithUnavailability.id];
  const isWithUa = configItemWithUAValue && configItemWithUAValue[0] === configItemWithUAYes;
  const shouldRenderUAForm = (shouldRender && isWithUa) || isCiUnavalability;

  currentFields.push({
    ...defaultFieldLogic,
    componentData: configItemUaType,
    shouldRender: shouldRenderUAForm,
    shouldValidate: shouldRenderUAForm,
    overwriteSubmit: {
      overwrite: !shouldRenderUAForm,
      overwriteValue: null,
    },
  });

  // Start and end date fields. Should only show if the UA form should render
  // min and max dates are dependent on the CRQ start and end dates
  const constraints = getDateConstraints(outerFormData);

  // relationships section is only on mobile
  const selectedNetwork = MOBILE;

  currentFields.push({
    ...defaultFieldLogic,
    shouldRender: shouldRenderUAForm,
    componentData: sstUaScheduledStartDate,
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: {
      ...uaScheduledStartDate,
      initialValues: constraints.initialStartDate,
      vFParams: {
        ...uaScheduledStartDate.vFParams,
        minDate: constraints.minDate,
        maxDate: constraints.maxDate,
        selectedNetwork,
      },
    },
    shouldRender: shouldRenderUAForm,
    shouldValidate: shouldRenderUAForm,
    overwriteSubmit: {
      overwrite: !shouldRenderUAForm,
      overwriteValue: null,
    },
  });
  currentFields.push({
    ...defaultFieldLogic,
    shouldRender: shouldRenderUAForm,
    componentData: sstUaScheduledEndDate,
  });
  currentFields.push({
    ...defaultFieldLogic,
    componentData: {
      ...uaScheduledEndDate,
      initialValues: constraints.initialEndDate,
      vFParams: {
        ...uaScheduledEndDate.vFParams,
        minDate: constraints.minDate,
        maxDate: constraints.maxDate,
        selectedNetwork,
      },
    },
    shouldRender: shouldRenderUAForm,
    shouldValidate: shouldRenderUAForm,
    overwriteSubmit: {
      overwrite: !shouldRenderUAForm,
      overwriteValue: null,
    },
  });


  return currentFields;
};

export {
  getConfigItemFlow,
};



